import React from 'react';

import {ServerResponseHandler} from 'src/components/server-response-handler';
import {Skeleton} from 'src/components/skeleton';

import {Group} from '@pb/kit-component-group';
import {pluralize} from '@pb/kit-formatters';


import {GrantResourcesDetailsSkeleton} from './grant-respouces-details.skeleton';
import {useProductsGrantResources} from './useProductsGrantResources';

type Props = {
    grantId: string,
    totalCount: number,
};

export const ProductsGrantResourcesDetails = ({grantId, totalCount}: Props) => {
    const {
        isLoading,
        loadingError,
        data,
    } = useProductsGrantResources({grantId, pageSize: 250, pageNumber: 1});

    return (
        <Skeleton shown={isLoading} view={<GrantResourcesDetailsSkeleton totalCount={totalCount}/>}>
            <ServerResponseHandler
                smallView={true}
                serverError={loadingError}
                sectionName="Grant Resources">
                <Group direction="v" gap="xs">
                    <b>{pluralize(`${data.totalCount} resources:`, data.totalCount)}</b>
                    <br/>
                    {data.resources.map((resource, index) => (
                        <div key={index}>{resource.name}</div>
                    ))}
                </Group>
            </ServerResponseHandler>
        </Skeleton>
    );
};
